export const isValidQuery = (query: string | undefined) => {
    if (!query) return false;

    return /[A-Za-z0-9]/.test(query);
};
